import { OrderResultsTableColumnEnum } from '../_enums';

export const orderResultsTableTooltips: Record<OrderResultsTableColumnEnum, string> = {
    [OrderResultsTableColumnEnum.SAMPLE_NAME]: '',
    [OrderResultsTableColumnEnum.PRIMER_NAME]: '',
    [OrderResultsTableColumnEnum.ORDER_NAME]: '',
    [OrderResultsTableColumnEnum.REACTION_STATUS]: '',
    [OrderResultsTableColumnEnum.QC_LEVEL]: 'order.results.table.column.qcLevel.tooltip',
    [OrderResultsTableColumnEnum.LENGTH]: 'order.results.table.column.length.tooltip',
    [OrderResultsTableColumnEnum.QV20_PLUS]: 'order.results.table.column.qv20Plus.tooltip',
    [OrderResultsTableColumnEnum.RESULTED]: '',
    [OrderResultsTableColumnEnum.RETEST_STATUS]: '',
    [OrderResultsTableColumnEnum.DOWNLOAD]: '',
};
